//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { Outlet } from "react-router-dom";
import BranchIcon from "../Icons/BranchIcon";
import CustomerIcon from "../Icons/CustomerIcon";
import DispatchManifestIcon from "../Icons/DispatchManifestIcon";
import MerchantIcon from "../Icons/MerchantIcon";
import OrderIcon from "../Icons/OrderIcon";
import OverViewIcon from "../Icons/OverViewIcon";
import PickUpRequest from "../Icons/PickUpRequest";
import ReceiveManifestIcon from "../Icons/ReceiveManifestIcon";
import RiderIcons from "../Icons/RiderIcons";
import RunsheetIcon from "../Icons/RunsheetIcon";
import StaffIcon from "../Icons/StaffIcon";
import TrashIcon from "../Icons/TrashIcon";
import DashboardLayoutService from "../components/DashboardLayout";

export const navigation: any = [
  {
    name: "Dashboard",
    href: "/",
    icon: "",
    children: [
      {
        name: "Overview",
        href: "/",
        icon: OverViewIcon,
        activeIcon: OverViewIcon,
      },
      {
        name: "Merchant",
        href: "/merchant-overview",
        icon: MerchantIcon,
        activeIcon: MerchantIcon,
      },
      {
        name: "Rider",
        href: "/rider-overview",
        icon: RiderIcons,
        activeIcon: RiderIcons,
      },
      {
        name: "Branch",
        href: "/branch-overview",
        icon: BranchIcon,
        activeIcon: BranchIcon,
      },
    ],
  },
  {
    name: "Operations",
    href: "/",
    icon: "",
    children: [
      {
        name: "Orders",
        href: "/order",
        icon: OrderIcon,
        activeIcon: OrderIcon,
        children: [],
      },
      {
        name: "Trash Orders",
        href: "/trash-order",
        icon: TrashIcon,
        activeIcon: TrashIcon,
        children: [],
      },
      {
        name: "Runsheet",
        href: "/runsheet",
        icon: RunsheetIcon,
        activeIcon: RunsheetIcon,
        children: [],
      },
      {
        name: "Pickup Request",
        href: "/pickup-request",
        icon: PickUpRequest,
        activeIcon: PickUpRequest,
        children: [],
      },
      {
        name: "RTV/Return",
        href: "/return-orders",
        icon: PickUpRequest,
        activeIcon: PickUpRequest,
        children: [],
      },
      {
        name: "RTV Branch",
        href: "/return-branch",
        icon: PickUpRequest,
        activeIcon: PickUpRequest,
        children: [],
      },
    ],
  },
  {
    name: "Manifest",
    href: "/",
    icon: "",
    children: [
      {
        name: "Dispatch Manifest",
        href: "/dispatch-manifest",
        icon: DispatchManifestIcon,
        activeIcon: DispatchManifestIcon,
        children: [],
      },
      {
        name: "Receive Manifest",
        href: "/receive-manifest",
        icon: ReceiveManifestIcon,
        activeIcon: ReceiveManifestIcon,
        children: [],
      },
    ],
  },
  {
    name: "User Management",
    href: "/",
    icon: "",
    children: [
      {
        name: "Customer",
        href: "/customer",
        icon: CustomerIcon,
        activeIcon: CustomerIcon,
      },
      {
        name: "Staff",
        href: "/staff",
        icon: StaffIcon,
        activeIcon: StaffIcon,
      },
      {
        name: "Rider/Driver",
        href: "/rider",
        icon: RiderIcons,
        activeIcon: RiderIcons,
      },
      {
        name: "Merchant",
        href: "/merchant",
        icon: MerchantIcon,
        activeIcon: MerchantIcon,
      },
    ],
  },
  {
    name: "Finance/Invoice",
    href: "/",
    icon: "",
    children: [
      {
        name: "Merchant",
        href: "/finance-merchant-invoice",
        icon: MerchantIcon,
        activeIcon: MerchantIcon,
      },
      {
        name: "Rider",
        href: "/finance-rider-invoice",
        icon: RiderIcons,
        activeIcon: RiderIcons,
      },
      {
        name: "Branch",
        href: "/finance-branch-invoice",
        icon: BranchIcon,
        activeIcon: BranchIcon,
      },
    ],
  },
  // {
  //   name: "Administration",
  //   href: "/",
  //   icon: "",
  //   children: [
  //     {
  //       name: "Settings",
  //       href: "/settings",
  //       icon: SettingIcon,
  //       activeIcon: SettingIcon,
  //     },
  //   ],
  // },
];

const DashboardLayout = () => {
  return (
    <DashboardLayoutService navigation={navigation}>
      <div className={tw`h-full p-2 overflow-y-auto`}>
        <Outlet />
      </div>
    </DashboardLayoutService>
  );
};

export default DashboardLayout;
